export const iconFontAwesomeHumanitarianPlugCircleExclamation = (
	<i className="fa-solid fa-plug-circle-exclamation"></i>
);
